import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';
import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { DomElementEvent } from 'pf-frontend-common/src/module/dom/element.event';
import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';
import { ViewOptionsInterface } from 'pf-frontend-common/src/module/view/options.interface';

import { DomCallRevealButtonEvent } from 'common/module/dom/call-reveal-button.event';
import { DomCallRevealButtonInterface } from 'common/module/dom/call-reveal-button.interface';

/**
 * Switch the visibility of a button's label and value
 */
export class DomCallRevealButton implements DomCallRevealButtonInterface {
  private readonly cssSelector: DataKeyValueStringInterface = {
    label: '.button__text-label',
    value: '.button__text-value',
  };

  private readonly cssClass: DataKeyValueStringInterface = {
    hide: 'button__text--is-hidden',
  };

  /**
   * HTML Button element
   */
  private element: HTMLElement;

  /**
   * Is the value revealed
   */
  private isRevealed: boolean;

  /**
   * Constructor
   */
  constructor(private eventEmitter: EventEmitterInterface) {}

  /**
   * @inheritDoc
   */
  public initialize(options: ViewOptionsInterface): void {
    this.element = options.element;

    this.setRevealed(false);
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    this.element.addEventListener(DomElementEvent.click, this.onClickButton);

    this.renderHTML();
  }

  /**
   * @inheritDoc
   */
  public getEventEmitter(): EventEmitterInterface {
    return this.eventEmitter;
  }

  /**
   * Show the button's value and hide its label
   */
  private setRevealed(shouldReveal: boolean): void {
    this.isRevealed = shouldReveal;
  }

  /**
   * Render the button's HTML based on the value of the reveal button
   */
  private renderHTML(): void {
    const phoneButtonLabel = domQuerySelector(this.element, this.cssSelector.label);
    const phoneButtonValue = domQuerySelector(this.element, this.cssSelector.value);

    if (this.isRevealed) {
      phoneButtonLabel.classList.add(this.cssClass.hide);
      phoneButtonValue.classList.remove(this.cssClass.hide);
    } else {
      phoneButtonLabel.classList.remove(this.cssClass.hide);
      phoneButtonValue.classList.add(this.cssClass.hide);
    }
  }

  /**
   * If the button hasn't been clicked before, reveal its value
   */
  private onClickButton = (e: Event): void => {
    e.preventDefault();

    if (this.isRevealed) {
      return;
    }

    this.setRevealed(true);
    this.renderHTML();
    this.eventEmitter.emit(DomCallRevealButtonEvent.reveal);
  };
}
